"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var keycode_1 = __importDefault(require("keycode"));
var ensureArray_1 = __importDefault(require("@zapier/common-utils/dist/ensureArray"));
// use this function in conjunction with any key event to create handlers for specific keys.
var createKeyHandler = function (keys, onKey) { return function (e) {
    var keysArray = ensureArray_1.default(keys);
    var hasAnyMatchingKeys = lodash_1.default.some(keysArray, function (key) { return e.keyCode === Number(keycode_1.default(key)); });
    if (hasAnyMatchingKeys) {
        onKey(e);
    }
}; };
exports.default = createKeyHandler;
